import { Link } from "react-router-dom";

const posts = [
  {
    id: 1,
    category: "Hair Care",
    title: "The European Balayage Technique: Why It Looks So Natural",
    excerpt: "Discover the hand-painting method perfected in French salons that creates the most luminous, sun-kissed dimension for women 30–50.",
    date: "April 8, 2026",
    readTime: "5 min read",
    image: "https://public.readdy.ai/ai/img_res/2ef62de458d14c85c68622c58b5f0019.jpg",
  },
  {
    id: 2,
    category: "Trends",
    title: "Spring 2026 Color Trends Our Stylists Are Obsessed With",
    excerpt: "From buttery blondes to rich espresso tones — our European-trained team breaks down the season's most wearable color stories.",
    date: "March 25, 2026",
    readTime: "4 min read",
    image: "https://readdy.ai/api/search-image?query=spring%20hair%20color%20trends%202026%20collection%20beautiful%20women%20hair%20swatches%20palette%20warm%20golden%20copper%20tones%20editorial%20beauty%20photography%20luxury%20salon&width=800&height=500&seq=blog2&orientation=landscape",
  },
  {
    id: 3,
    category: "Hair Health",
    title: "Olaplex vs. Kérastase: Which Bond-Building Treatment Is Right for You?",
    excerpt: "We put the two most coveted bond-builders head to head. Here's what our stylists recommend based on your hair type and history.",
    date: "March 10, 2026",
    readTime: "6 min read",
    image: "https://readdy.ai/api/search-image?query=luxury%20hair%20treatment%20products%20Olaplex%20Kerastase%20bottles%20on%20marble%20counter%20salon%20professional%20hair%20care%20editorial%20photography%20clean%20minimal%20background&width=800&height=500&seq=blog3&orientation=landscape",
  },
];

export default function JournalBlog() {
  return (
    <section className="w-full bg-[#faf8f5] py-24 px-6" id="journal">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-14">
          <span className="text-[#C9A96E] text-xs font-semibold tracking-[0.3em] uppercase mb-3 block">The Glam Edit</span>
          <h2 className="text-neutral-900 text-3xl md:text-5xl font-bold" style={{ fontFamily: "'Playfair Display', serif" }}>
            Journal &amp; Beauty Insights
          </h2>
          <p className="text-neutral-500 mt-4 text-sm max-w-md mx-auto leading-relaxed">
            Expert tips, trend reports, and behind-the-chair stories from our European-trained stylists in Las Vegas.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {posts.map((post) => (
            <article key={post.id} className="bg-white rounded-lg overflow-hidden border border-neutral-100 group cursor-pointer hover:-translate-y-1 transition-transform duration-300">
              <div className="w-full h-52 overflow-hidden">
                <img src={post.image} alt={post.title} className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500" />
              </div>
              <div className="p-6">
                <div className="flex items-center gap-3 mb-3">
                  <span className="text-[#C9A96E] text-xs font-bold tracking-widest uppercase">{post.category}</span>
                  <span className="text-neutral-300 text-xs">·</span>
                  <span className="text-neutral-400 text-xs">{post.readTime}</span>
                </div>
                <h4 className="text-neutral-900 font-bold text-base leading-snug mb-3" style={{ fontFamily: "'Playfair Display', serif" }}>
                  <a href="#journal" className="hover:text-[#C9A96E] transition-colors">{post.title}</a>
                </h4>
                <p className="text-neutral-500 text-sm leading-relaxed mb-5">{post.excerpt}</p>
                <div className="flex items-center justify-between">
                  <span className="text-neutral-400 text-xs">{post.date}</span>
                  <Link to="/blog" className="text-[#C9A96E] text-xs font-semibold tracking-widest uppercase hover:underline whitespace-nowrap cursor-pointer">Read More</Link>
                </div>
              </div>
            </article>
          ))}
        </div>
        <div className="text-center mt-12">
          <Link to="/blog" className="inline-block border border-[#C9A96E] text-[#C9A96E] text-sm font-semibold tracking-widest uppercase px-12 py-4 rounded-sm hover:bg-[#C9A96E] hover:text-white transition-colors duration-200 whitespace-nowrap cursor-pointer">
            View All Articles
          </Link>
        </div>
      </div>
    </section>
  );
}
